document.querySelectorAll('.js-accordion-trigger').forEach((element) => {
  element.addEventListener('click', (event) => {
  event.preventDefault();
    console.log(event.currentTarget.parentElement)
  let trigger = event.currentTarget

  if (trigger.parentElement.classList.contains('is-active')) {
    trigger.nextElementSibling.style.display = 'none'
    trigger.parentElement.classList.remove('is-active')
  } else {
    trigger.nextElementSibling.style.display = 'block'
    trigger.parentElement.classList.add('is-active')
  }
})
  
})
  
  
  